import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';  
import { useEffect, useState } from 'react';  
import Navigation from './components/Navigation';  
import ProtectedRoute from './components/ProtectedRoute';  
import Ecosystem from './components/Ecosystem';  
import Quests from './components/Quests';  
import Home from './components/Home';  
import Lootbox from './components/Lootbox';  
import Wallet from './components/Wallet';
import { TelegramProvider } from './context/TelegramProvider';   
import { AuthProvider } from './context/AuthContext';  
import ConnectExternalWallet from './components/ConnectExternalWallet';
// import { verifyTelegramUser } from './services/api';  
  
function App() {   
  
  return ( 
    <TelegramProvider> 
    <AuthProvider>  
      <Router>  
        <div className="flex flex-col h-screen">  
          <div className="flex-1 overflow-y-auto pb-20 w-full max-w-[500px] mx-auto">    
            <Routes>  
              <Route   
                path="/"   
                element={  
                  <ProtectedRoute>  
                    <Home />  
                  </ProtectedRoute>  
                }   
              />  
              <Route   
                path="/ecosystem"   
                element={  
                  <ProtectedRoute>  
                    <Ecosystem />  
                  </ProtectedRoute>  
                }   
              />  
              <Route   
                path="/quests"   
                element={  
                  <ProtectedRoute>  
                    <Quests />  
                  </ProtectedRoute>  
                }   
              />  
              <Route   
                path="/lootbox"   
                element={  
                  <ProtectedRoute>  
                    <Lootbox />  
                  </ProtectedRoute>  
                }   
              />  
              <Route   
                path="/wallet"   
                element={  
                  <ProtectedRoute>  
                    <Wallet />  
                  </ProtectedRoute>  
                }   
              />  
              <Route   
                path="/connect-external-wallet"   
                element={  
                  <ProtectedRoute>  
                    <ConnectExternalWallet />  
                  </ProtectedRoute>  
                }   
              />
            </Routes>  
          </div>  
          <Navigation />  
        </div>  
      </Router>  
    </AuthProvider> 
    </TelegramProvider> 
  );  
}  
  
export default App;